// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__j35Bs","placeholdersHeader":"styles_placeholdersHeader__2KvCI","editorStyle":"styles_editorStyle__19-Vv","placeholdersBox":"styles_placeholdersBox__2Puvi"};